import React from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineSeparator from '@mui/lab/TimelineSeparator'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import Typography from '@mui/material/Typography'
import { formatLocal, formatUTC } from 'utils/date'

import { translate } from 'locales'

// Styles
import { Title, Loading, CardDate } from 'components'
import noData from 'assets/images/no-data.svg'
import * as S from './styles'
import {
  Timeline,
  TimelineContent,
  TimelineOppositeContent,
} from '../timelineStyles'

import TimeLineFollowUp from './TimeLineFollowUp'
import useFetch from 'hooks/useFetch'

const FollowUp: React.FunctionComponent<{
  doctorName: string
  userId: string
}> = ({ doctorName, userId }) => {
  const { data: timeline, isLoading } = useFetch({
    url: `nursing/accompaniment/doctor/user/${userId}`,
    condition: !!userId,
    options: {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const formatData = () => {
    const resultFollowUp = timeline?.reduce((res: any, i: any) => {
      res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')] =
        res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')] || []

      res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')].push(i)

      return res
    }, {})
    return resultFollowUp
  }

  return (
    <S.SectionContent>
      {isLoading && (
        <Loading title={translate('medicalRecord.loadingAcompaniments')} />
      )}

      <span>{formatLocal(new Date(), 'EEEE, dd/MM/yyyy')}</span>
      <p>{`${translate('medicalRecord.by')} ${doctorName}`}</p>

      <div className="subsection">
        <Title text={translate('medicalRecord.historicAcompaniments')} />
        <div className="subsection-item">
          <Timeline position="right">
            {timeline && Object.keys(timeline).length === 0 && (
              <S.NoData>
                <img
                  src={noData}
                  alt="Icone simbolizando que não existe acompanhamento do paciente"
                />
                <span>{translate('medicalRecord.notAccompaniment')}</span>
              </S.NoData>
            )}

            {formatData() &&
              Object.keys(formatData())?.map((record: any) => (
                <TimelineItem key={record}>
                  <TimelineOppositeContent>
                    <CardDate
                      day={formatUTC(record, 'dd')}
                      month={formatUTC(record, 'MMM')}
                      year={formatUTC(record, 'yyyy')}
                    />
                  </TimelineOppositeContent>
                  <TimelineSeparator>
                    <TimelineDot />
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    {formatData()[record]?.map((i: any) => (
                      <Accordion key={i.id}>
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1a-content"
                          id={i.id}
                        >
                          <Typography>
                            {`${translate('medicalRecord.by')} ${
                              i?.nursing?.name
                            }`}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ display: 'block' }}>
                          <TimeLineFollowUp
                            record={i}
                            doctorName=""
                            scheduleUUID=""
                          />
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </TimelineContent>
                </TimelineItem>
              ))}
          </Timeline>
        </div>
      </div>
    </S.SectionContent>
  )
}

export default FollowUp
